'use server'

import { dictionaryFor } from '@/lib/i18n/dictionary'
import { getLocale } from '@/lib/locale'

const BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL ?? 'https://cloud.maximus.mn/api/website/v1'

export type ContactState = {
  status: 'idle' | 'ok' | 'error'
  message?: string
  errors?: Record<string, string[]>
}

/**
 * Холбоо барих маягтыг cloud руу дамжуулна.
 *
 * ⚠️ Хөтчөөс ШУУД cloud руу илгээхгүй: server action-оор явуулснаар CORS
 * тохируулах шаардлагагүй бөгөөд хэрэглэгчийн IP, throttle нь cloud талдаа
 * нэг цэгээс хянагдана.
 */
export async function sendContactMessage(_previous: ContactState, formData: FormData): Promise<ContactState> {
  const locale = await getLocale()
  const t = dictionaryFor(locale)

  const payload = {
    name: String(formData.get('name') ?? '').trim(),
    email: String(formData.get('email') ?? '').trim(),
    phone: String(formData.get('phone') ?? '').trim(),
    company: String(formData.get('company') ?? '').trim(),
    subject: String(formData.get('subject') ?? '').trim(),
    message: String(formData.get('message') ?? '').trim(),

    /* Хүн харахгүй талбар — бөглөгдсөн бол cloud тал чимээгүй хаяна */
    website: String(formData.get('website') ?? '')
  }

  try {
    const response = await fetch(`${BASE_URL}/contact?locale=${locale}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
      cache: 'no-store'
    })

    const body = (await response.json().catch(() => ({}))) as { message?: string; errors?: Record<string, string[]> }

    if (response.ok) {
      return { status: 'ok', message: body?.message ?? t.contact.thanks }
    }

    return {
      status: 'error',
      message: body.message ?? t.contact.error,
      errors: body.errors
    }
  } catch {
    return { status: 'error', message: t.contact.error }
  }
}
